/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ContactFinderListItem } from '@gh/builder-shared';
import { CostCenterDetailsDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';
import { OptimisticLockingSupport } from '@gh/core-data';
import { find, get, omit } from 'lodash';

export class CostCenterSupplier {
  constructor(public contactId: ID,
              public contactName: string,
              public supplierId?: ID) {
  }
}

export class CostCenterDetails implements OptimisticLockingSupport {
  constructor(public isInJobSchedule: boolean,
              public suppliers: CostCenterSupplier[],
              public name: string,
              public scheduledDays: number,
              public id?: ID,
              public etag?: string,
              public preferredSupplier?: ID) {
  }
}

export function costCenterDetailsFromDto(dto: CostCenterDetailsDto): CostCenterDetails {
  return {
    ...dto,
    preferredSupplier: get(find(dto.suppliers, { isPreferred: true }), 'contactId', void 0),
    suppliers: dto.suppliers.map((supplier) => <CostCenterSupplier>omit(supplier, 'isPreferred')),
  };
}

export function costCenterDetailsToDto(model: CostCenterDetails): CostCenterDetailsDto {
  return <any>omit({
    ...model,
    suppliers: model.suppliers.map((supplier) => ({
      ...supplier,
      isPreferred: model.preferredSupplier === supplier.contactId,
    })),
  },               ['preferredSupplier']);
}

export function costCenterSupplierFromFound(found: ContactFinderListItem): CostCenterSupplier {
  return {
    contactId: found.id,
    contactName: found.name,
  };
}

export function newCostCenter(): CostCenterDetails {
  return {
    id: void 0,
    isInJobSchedule: false,
    preferredSupplier: void 0,
    name: '',
    scheduledDays: 1,
    suppliers: [],
  };
}
